const loaders = {
  showcase: () => import('app/pages/showcase'),
  welcome: () => import('app/pages/welcome'),
  dev: () => import('app/pages/dev'),
  seoPaths: () => import('app/pages/seo-paths'),
  activity: () => import('app/pages/activity'),
  login: () => import('app/pages/login'),
  register: () => import('app/pages/register'),
  confirmEmail: () => import('app/pages/confirm-email'),
  gameAccounts: () => import('app/pages/game-accounts'),
  accountsImport: () => import('app/pages/accounts-import'),
  gameAccountsVerification: () => import('app/pages/game-accounts-verification'),
  rateUserGames: () => import('app/pages/rate-games/pages/rate-user-games'),
  rateTopGames: () => import('app/pages/rate-games/pages/rate-top-games'),
  passwordRecovery: () => import('app/pages/password-recovery'),
  passwordReset: () => import('app/pages/password-reset'),
  feedback: () => import('app/pages/feedback'),
  settings: () => import('app/pages/settings'),
  settingsInfo: () => import('app/pages/settings/settings-info'),
  settingsGameAccounts: () => import('app/pages/settings/settings-game-accounts'),
  settingsGameAccountsVerification: () => import('app/pages/settings/settings-game-accounts-verification'),
  settingsSocialAccounts: () => import('app/pages/settings/settings-social-accounts'),
  settingsNotifications: () => import('app/pages/settings/settings-notifications'),
  settingsPassword: () => import('app/pages/settings/settings-password'),
  settingsEmail: () => import('app/pages/settings/settings-email'),
  settingsAdvanced: () => import('app/pages/settings/settings-advanced'),
  settingsExport: () => import('app/pages/settings/settings-export'),
  settingsDeleteProfile: () => import('app/pages/settings/settings-delete-profile'),
  releaseDates: () => import('app/pages/release-dates'),
  reviews: () => import('app/pages/reviews'),
  gamesRoutes: () => import('app/pages/games-routes'),
  gamesStaticFilters: () => import('app/pages/games-static-filters'),
  browseListing: () => import('app/pages/browse-listing'),
  browse: () => import('app/pages/browse/pages/browse'),
  suggestions: () => import('app/pages/suggestions/pages/suggestions'),
  suggestionsEntity: () => import('app/pages/suggestions/pages/entity'),
  ampGame: () => import('app/pages/amp/game'),
  gameScreenshots: () => import('app/pages/game/game-screenshots'),
  gameScreenshot: () => import('app/pages/game-screenshot'),
  gameSuggestions: () => import('app/pages/game/game-suggestions'),
  gameAchievements: () => import('app/pages/game/game-achievements'),
  gameCollections: () => import('app/pages/game/game-collections'),
  gameReviews: () => import('app/pages/game/game-reviews'),
  gamePosts: () => import('app/pages/game/game-posts'),
  gameImgur: () => import('app/pages/game/game-imgur'),
  gameReddit: () => import('app/pages/game/game-reddit'),
  gameTwitch: () => import('app/pages/game/game-twitch'),
  gameYoutube: () => import('app/pages/game/game-youtube'),
  gameTeam: () => import('app/pages/game/game-team'),
  gamePatches: () => import('app/pages/game/game-patches'),
  gamePatch: () => import('app/pages/game/game-patch'),
  gameDemos: () => import('app/pages/game/game-demos'),
  gameDemo: () => import('app/pages/game/game-demo'),
  gameCheats: () => import('app/pages/game/game-cheats'),
  gameCheat: () => import('app/pages/game/game-cheat'),
  gameReview: () => import('app/pages/game/game-review'),
  gameEditCommon: () => import('app/pages/game-edit/pages/common'),
  gameEditBasic: () => import('app/pages/game-edit/pages/basic'),
  gameEditScreenshots: () => import('app/pages/game-edit/pages/screenshots'),
  gameEditStores: () => import('app/pages/game-edit/pages/stores'),
  gameEditTags: () => import('app/pages/game-edit/pages/tags'),
  gameEditCreators: () => import('app/pages/game-edit/pages/creators'),
  gameEditLinkedGames: () => import('app/pages/game-edit/pages/linked-games'),
  person: () => import('app/pages/person'),
  profile: () => import('app/pages/profile'),
  profileOverview: () => import('app/pages/profile/profile-overview'),
  profileGames: () => import('app/pages/profile/profile-games'),
  profileCollections: () => import('app/pages/profile/profile-collections'),
  profileConnections: () => import('app/pages/profile/profile-connections'),
  profileReviews: () => import('app/pages/profile/profile-reviews'),
  profileDeveloper: () => import('app/pages/profile/profile-developer'),
  profileApiKey: () => import('app/pages/profile/profile-apikey'),
  collectionCreate: () => import('app/pages/collection/pages/create'),
  collectionEdit: () => import('app/pages/collection/pages/edit'),
  collection: () => import('app/pages/collection/pages/collection'),
  collectionSuggest: () => import('app/pages/collection/pages/suggest'),
  collectionAdd: () => import('app/pages/collection/pages/add'),
  collectionFeedItemText: () => import('app/pages/collection/pages/feed-item-text'),
  collections: () => import('app/pages/collections/pages/collections'),
  search: () => import('app/pages/search'),
  reviewCreate: () => import('app/pages/review/review-create'),
  reviewEdit: () => import('app/pages/review/review-edit'),
  review: () => import('app/pages/review'),
  postCreate: () => import('app/pages/post/post-create'),
  postEdit: () => import('app/pages/post/post-edit'),
  post: () => import('app/pages/post'),
  internalServerError: () => import('app/pages/internal-server-error'),
  notFoundError: () => import('app/pages/not-found-error'),
  privacyPolicy: () => import('app/pages/privacy-policy'),
  privacy: () => import('app/pages/privacy'),
  agreement: () => import('app/pages/agreement'),
  tosApi: () => import('app/pages/tos-api'),
  apiPurchaseSuccess: () => import('app/pages/api-purchase-success'),
  // agWelcomeBack: () => import('app/pages/ag-welcome-back'),
  // apidocs: () => import('app/pages/apidocs'),
  terms: () => import('app/pages/terms'),
  serviceGA: () => import('app/pages/service/google-analytics'),
  leaderboard: () => import('app/pages/leaderboard'),
  sitemap: () => import('app/pages/sitemap'),
  // tokensDashboard: () => import('app/pages/tokens'),
  // tokensExchange: () => import('app/pages/tokens-exchange'),
  // tokensOffer: () => import('app/pages/tokens/components/offer-details'),
  embeddedStories: () => import('app/pages/embedded/stories'),
  discoverMain: () => import('app/pages/discover-main'),
  discoverSections: () => import('app/pages/discover/pages/sections'),
  discoverSuggestions: () => import('app/pages/discover/pages/suggestions'),
  discoverSearch: () => import('app/pages/discover/pages/search'),

  giveawayRules: () => import('app/pages/giveaway-rules/giveaway-rules'),
  pay: () => import('app/pages/pay'),

  // Лоадеры AG-версии сайта
  program: () => import('app/pages/program'),
};

export default loaders;
